import React, { useState, useEffect } from "react";
import { getAxiosResponse, putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { useSelector } from "react-redux";
import Constants from "../../../Constants";
import APIUrls from "../../../services/APIUrls";
import { useParams } from "react-router-dom";
import $ from "jquery";
import { transformBlankToNull } from "../../../services/Util";
import OverviewAlerts from "./OverviewAlerts";
import RequestTranslationAgain from "./RequestTranslationAgain";
import { RotatingLines } from "react-loader-spinner";
import { useRef } from "react";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { ConditionalBlock } from "../../../ConditionalBlock";

export default function InternalTranslator(prop) {
  const [popupStatus, setPopupStatus] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [internalTranslation, setInternalTranslationRequest] = useState({});
  const [showRequestTranslationAgain, setShowRequestTranslationAgain] = useState(false);
  const [showLoader,setShowLoader] = useState(true);
  const projectStatus = prop.projectDetail.displayName[0].status
  const buttonRef= useRef()

  const refreshProject = () =>{
    getData();
  }

  const param = useParams();

  const owner = useSelector((reduxStore) => reduxStore.loginSession).value;

  const getData = () => {
    setShowLoader(true);
    getAxiosResponse(APIUrls.INTERNAL_REQUEST(param.id))
      .then((res) => {
        if (res.data !== "") {
          setInternalTranslationRequest(res.data.data);
          setShowLoader(false);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  
  const messages = {
    "PENDING":"Waiting for Internal Translator to Respond",
    "ACCEPTED":"Request Accepted",
    "REJECTED":"Request Rejected"
  }

  useEffect(() => {
    getData();
  }, []);

  const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;

  const showPopup = (status,event) => {
    setPopupStatus(status);
    showModel(event);
  };
  const showModel = (event) => {
    buttonRef.current= event?.target;
    document.body.classList.add("modal-open");
    setTimeout(() => {
    $('#close-popup-id').trigger('focus')

    $('#cancel-id').keydown(function(event) {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#close-popup-id").trigger("focus");
      }
    }
  })

  $('#close-popup-id').keydown(function(event) {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === true) {
        event.preventDefault();
        $("#cancel-id").trigger("focus");
      }
    }
  }
  )

  $(".inner-lightbox-panel").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      hideModel();
      $(buttonRef.current).trigger('focus');
    }
  });

    },500);
  };

  const showRequestTranslationAgainModel = () => {
    document.body.classList.add("modal-open-7");
  };

  const hideModel = () => {
    document.body.classList.remove("modal-open");
    $(buttonRef.current).trigger('focus');
  };

  const hideRequestTranslationAgainModel = () => {
    document.body.classList.remove("modal-open-7");
  };

  const rejectTranslationQuote = () => {
    internalTranslation.status = "REJECTED";
    internalTranslation.rejectionReason = rejectReason;
    var payload = transformBlankToNull(internalTranslation);
    putAxiosResponse(
      APIUrls.INTERNAL_REQUEST(param.id),
      payload
    ).then((res) => {
      hideModel();
      setPopupStatus("");
      prop.refresh('internalTranslator')
    });
  };
  const acceptTranslationQuote = () => {
    internalTranslation.status = "ACCEPTED";
    var payload = transformBlankToNull(internalTranslation);
    putAxiosResponse(
      APIUrls.INTERNAL_REQUEST(param.id),
      payload
    ).then((res) => {
      hideModel();
      setPopupStatus("");
      prop.refresh('internalTranslator')
    });
  };
  const addRejectReason = (value) => {
    setRejectReason(value);
  };

  const isContextUserAssignee = () => {
    if(internalTranslation.assigneeUser !== undefined) {
      return owner.id === internalTranslation.assigneeUser.userId;
    }
  }

  const showRequestTranslationAgainAlertModel = () => {
    if(showRequestTranslationAgain) {
      setShowRequestTranslationAgain(false);
      hideRequestTranslationAgainModel();
    } else {
      setShowRequestTranslationAgain(true);
      showRequestTranslationAgainModel()
    }
  }

  return (
    projectStatus.preparingProject ?
    
    <div className="listing-content relative">
      <div className="source-file">
      <h4>OPAL-Marketing is preparing this project for internal translation. Check back in a few minutes.</h4>
     </div>
   </div> :
    <div className="listing-content relative">
      {!showLoader ? <>
      {internalTranslation.status === "PENDING" ? (
        <div className="campaign_details-task campaign-form">
          <div className="projects-heading">
            <h5>Translation Request</h5>
          </div>
          {internalTranslation?.assigneeUser?.userId === owner.id && <div>
            <p>
              You have been asked to perform the translations for this project.
            </p>
          </div>}
          <div>
            {prop.projectDetail.resource.projectResource.notes !== "" ? (
              <p>
                <b>Notes and Instructions :</b>{" "}
                {prop.projectDetail.resource.projectResource.notes}{" "}
              </p>
            ) : ( "" )}
            <p>
              <b>First Translation Deadline :</b>{" "}
              {prop.projectDetail.resource.projectResource.deliveryDueDate.dateWithTime}
            </p>
            <p>
              <b>Requested Date :</b>{" "}
              {internalTranslation.createdDate?.dateWithTime}
            </p>
            <p>
              <b>Internal Translator :</b>{" "}
              {internalTranslation.assigneeUser.firstName+" "+internalTranslation.assigneeUser.lastName}{" "}
            </p>
            <p>
              <b>Status :</b>{" "}
              {messages[internalTranslation.status]}{" "}
            </p>
            {internalTranslation.status === "REJECTED" ?
              <p>
              <b>Reason for Rejection :</b>{" "}
              {internalTranslation.rejectionReason}{" "}
            </p> : ''}
          </div>
     {internalTranslation.assigneeUser.userId === owner.id ?
  <div className="flex justify-end btn-gap">
            <button
              className="blue-btn active"
              onClick={(event) => showPopup("accept",event)}

            >
              Accept
            </button>
            <button className="blue-btn " onClick={(event) => showPopup("reject", event)} id='reject-id'>
              Reject
            </button>
          </div> : ''
}
          

        </div>
      ) : (
        <div className="campaign_details-task campaign-form">
          <div className="mar-bot10">
            <ConditionalBlock condition={!isContextUserAssignee()}>
              <OverviewAlerts project={prop.projectDetail} requestTranslationAgainFunct={showRequestTranslationAgainAlertModel}/>
            </ConditionalBlock>
          </div>
          <div className="projects-heading">
            <h5>Internal Translator</h5>
          </div>

          <div className="projects-content">
            <div className="table-responsive global-table">
      <table className="sortable" aria-label="Internal Translator" tabIndex='0'>
                <thead>
                  <tr>
                    <th className="no-sort">First Translation Deadline</th>
                    <th className="no-sort">Requested Date</th>
                    <th className="no-sort">Internal Translator</th>
                    <th className="no-sort">Status</th>
                    {internalTranslation.rejectionReason && internalTranslation.rejectionReason !== '' ? 
                    <th className="no-sort">Reason for Rejection</th> : ''
                  }
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{prop.projectDetail.resource.projectResource.deliveryDueDate.dateWithTime}</td>
                    <td>{internalTranslation.createdDate?.dateWithTime}</td>
                    <td> {internalTranslation?.assigneeUser?.firstName + " " + internalTranslation?.assigneeUser?.lastName}</td>
                    <td>{internalTranslation.status}</td>
                    {internalTranslation.rejectionReason && internalTranslation.rejectionReason !== '' ?
                    <td className="no-sort">{internalTranslation.rejectionReason}</td> : ''
                  }
                  </tr>
                </tbody>
              </table>

              {/* <div className="no-data-display align-center">
                  <i className="nodata-icon"></i>
                  <p>Currently there are no change orders.</p>
                </div> */}
            </div>
          </div>
        </div>
      )}</> : (
        <div className={showLoader ? "gb-overlay show" : "gb-overlay hide"}>
              <div className="gb-loader">
                <RotatingLines
                  strokeColor="#0096FF"
                  strokeWidth="5"
                  width="196"
                  visible={true}
                />
              </div>
            </div>
      )}

      <div id="modelPopup" className="lightbox-panel approved-popup " aria-labelledby="translator-heading" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel">
          <div className="modal-header flex">
            <strong id='translator-heading'>
              {popupStatus === "accept"
                ? "Confirmation"
                : popupStatus === "reject"
                ? "Reject Internal Translation Request"
                : ""}
            </strong>
            <button
              className="close"
              aria-label="close"
              id='close-popup-id'
              onClick={hideModel}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                  fill="white"
                ></path>
                <path
                  d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                  fill="white"
                ></path>
              </svg>
            </button>
          </div>
          {popupStatus === "reject" ? (
            <>
              <div className="lightbox-content">
                <p>
                Please provide a reason for rejecting this request:
                </p>
                <div className="translate-box flex"></div>
                <div className="form-group">
                  <div className="form-text">
                    <textarea
                      className="textarea form-control-sm"
                      placeholder="500 characters limit"
                      maxLength={500}
                      onChange={(event) => addRejectReason(event.target.value)}
                      aria-label="Please provide a reason for rejecting this request"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="modal-footer flex">
                <button
                  className="btn btn-bold active"
                  onClick={rejectTranslationQuote}
                  id='submit-id'
                >
                  Submit
                </button>
                <button className="btn btn-bold" onClick={hideModel} id='cancel-id'>
                  Cancel
                </button>
              </div>
            </>
          ) : popupStatus === "accept" ? (
            <>
              <div className="lightbox-content">
                <p>
                Click Accept to accept the internal translation request and start the translation process. This action is not reversible.
                </p>
              </div>
              <div className="modal-footer flex">
                <button
                  className="btn btn-bold active"
                  onClick={acceptTranslationQuote}
                >
                  Accept
                </button>
                <button className="btn btn-bold" onClick={hideModel}>
                  Cancel
                </button>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      {showRequestTranslationAgain && <RequestTranslationAgain projectDetails={prop.projectDetail} refresh={refreshProject} closePopup={showRequestTranslationAgainAlertModel}/>}
      
    </div>
  );
}
